import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/suppliers/$supplierId")({
  component: lazyRouteComponent(() => import("./+SupplierLayout")),
  beforeLoad: () => ({
    breadcrumb: "Edit Supplier",
  }),
  head: () => ({
    meta: seo({ title: "Edit Supplier" }),
  }),
});
